module.exports = __webpack_public_path__ + "img/bridges_3.7b168bdd.jpg";